import { api } from './api'
import type { GrowthEventParams } from '~/services/musicService'

export async function sendShareGrowthEvent(event: GrowthEventParams) {
  if (typeof window === 'undefined') return
  // Both attempts retain the original event ID and body. An accepted=false
  // response (including deduplication / rate limiting) is terminal.
  for (let attempt = 0; attempt < 2; attempt++) {
    try {
      const response = await api.post<any>('music/public/v1/growth/events', event, {
        musicmintInlineError: true,
        ...(event.event_type === 'skip' ? { adapter: 'fetch', fetchOptions: { keepalive: true } } : {}),
      })
      if (response.code !== 500) return
    } catch { /* One bounded retry for a network failure. */ }
  }
}
